import { ref } from 'vue'
import { FilterMatchMode } from 'primevue/api'
import useClient from '../client/apiClient'

export default function useTMovimientos() {
  const tmovimiento = ref([])
  const tmovimientos = ref([])
  const tipoTMovimientos = ref([])
  const tmovimientosDelete = ref([])

  const client = useClient()

  const dt = ref({})
  const loading = ref(false)
  const saving = ref(false)

  const selectedTMovimientos = ref()
  const deleteTMovimientosDialog = ref(false)
  const deleteTMovimientoDialog = ref(false)
  const tmovimientoDialog = ref(false)
  const submitted = ref(false)
  const tipos = ref(['NORMAL', 'ADICIONAL'])
  const filteredTipo = ref()

  const getCRUD = async () => {
    loading.value = true
    client.get(`/api/tmovimientos/all/crud`).then(response => {
      tmovimientos.value = response.data.data.tmovimientos
      tipoTMovimientos.value = response.data.data.tmovimientos
      loading.value = false
    })
  }

  const storeTMovimiento = async (form) => {
    saving.value = true
    let id = tmovimiento.value.id
    if (id) {
      //Esta editando el registro
      client.put(`/api/tmovimientos/${id}`, { 'data': { ...form } })
        .then(() => {
          saving.value = !saving.value
          tmovimientoDialog.value = false
          getCRUD()
        })
    } else {
      //Esta creando el registro
      client.post(`/api/tmovimientos`, { 'data': { ...form } })
        .then(() => {
          tmovimientoDialog.value = client.dialog.value
          tmovimiento.value = client.entity.value
          saving.value = client.saving.value
          getCRUD()
        })
    }
  }

  const deleteTMovimiento = async () => {
    client.remove(`/api/tmovimientos/${tmovimiento.value.id}`)
      .then(response => {
        tmovimientos.value = tmovimientos.value.filter(val => val.id !== tmovimiento.value.id)
        deleteTMovimientoDialog.value = false
        tmovimiento.value = {}
      })
  }

  const deleteSelectedTMovimientos = async () => {
    tmovimientosDelete.value = selectedTMovimientos.value.map(({ id }) => id)
    client.remove(`/api/tmovimientos/destroy/mass`, { data: tmovimientosDelete.value })
      .then(response => {
        tmovimientos.value = tmovimientos.value.filter(
          (val) => !selectedTMovimientos.value.includes(val)
        )
        deleteTMovimientosDialog.value = false
        selectedTMovimientos.value = null
        tmovimientosDelete.value = null
      })
  }

  const filters = ref({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  return {
    tmovimiento,
    tmovimientos,
    tipos,
    dt,
    loading,
    saving,
    filters,
    selectedTMovimientos,
    deleteTMovimientosDialog,
    deleteTMovimientoDialog,
    tmovimientoDialog,
    submitted,
    filteredTipo,
    deleteSelectedTMovimientos,
    getCRUD,
    storeTMovimiento,
    deleteTMovimiento
  }
}